// extracted by mini-css-extract-plugin
export default {"generic-cta-style":"styles_generic-cta-style__O31Mo","half-width":"styles_half-width__QQKsM"};